import { Component, OnInit ,Input,SimpleChanges} from '@angular/core';
import { forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms'


@Component({
  selector: 'app-input-text',
  templateUrl: './input-text.component.html',
  styleUrls: ['./input-text.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputTextComponent),
      multi: true
    }
  ]
})
export class InputTextComponent implements OnInit {

  @Input() placeholder: string = 'Enter value';
  @Input() heading: string = 'Enter the text here';
  @Input() hint: string = 'Enter the hint here';
  @Input() isDisabled: boolean = false;
  @Input() id: string='id'
  @Input() minWords: number
  @Input() maxWords: number
  @Input() isRequired: boolean;


  // @Input() inputValue: string = ''; // Input value property
  // minWords:number
  // maxWords:number
  // inputValue:string

  isValid: boolean = true;
  isEmpty:boolean=false;
  value: string;
  onChange: any = () => {};
  onTouched: any = () => {};

  inputValue: string = ''; // Assuming inputValue is initialized properly
  storedValues: { [key: string]: string } = {}; // Object to store key-value pairs

 
  writeValue(value: any): void {
    this.value = value;
    this.onChange(value);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  constructor() { }

  ngOnInit(): void {
  }


  onInputChange(value: string,id:any): void {
    let span=(document.getElementById(`${id}_span`) as HTMLInputElement)
      span.style.display='none';
    // const errorSpan=(document.getElementById(`${id}-error`) as HTMLInputElement)
    // if(errorSpan){
    //   errorSpan.style.display="none";
    // }
    console.log(this.isRequired)
    const wordCount = value.length;
    // if(wordCount==0) this.isEmpty=true;
    if(this.maxWords && this.minWords){
      this.isValid = wordCount >= this.minWords && wordCount <= this.maxWords;
    }

  }
  

 

}
